import { lazy } from 'react';

export const ProductSelectionByDistributorPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "ProductSelectionByDistributorPage" */
      './ProductSelectionByDistributorPage'
    ),
);
